module.exports = __webpack_public_path__ + "static/media/metal-alloys-02.61a1fa4a.jpg";